import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  API_DELETE_NOTE,
  API_GET_NOTE,
  API_POST_ADD_NOTE,
  API_PUT_EDIT_NOTE,
} from "../../Apis/ApiEndPoints";
import { CustomAction } from "../../store/customAction";
import { Api } from "../..";
export interface IPostAddNoteRequestParams {
  providerId: string;
  customerId: any;
  createdTime: string;
  note: string;
}
export interface IPutEditNoteRequestParams {
  id: string;
  customerId: string | any;
  providerId: string | number;
  note: string;
}
export const PostAddNotes = createAsyncThunk(
  "notes/PostAddNotes",
  async (requestParams: IPostAddNoteRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_ADD_NOTE, requestParams),
      dispatch,
      "notes/PostAddNotes"
    );
    return response;
  }
);
export const GetNotes = createAsyncThunk(
  "notes/GetNotes",
  async (
    { providerId, customerId }: { providerId: string; customerId: any },
    { dispatch }
  ) => {
    const response = await CustomAction(
      Api.get(`${API_GET_NOTE}/${providerId}/${customerId}`),
      dispatch,
      "notes/GetNotes"
    );
    return response;
  }
);
export const PutEditNotes = createAsyncThunk(
  "notes/PutEditNotes",
  async (requestParams: IPutEditNoteRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.put(API_PUT_EDIT_NOTE, requestParams),
      dispatch,
      "notes/PutEditNotes"
    );
    return response;
  }
);
export const DeleteNotes = createAsyncThunk(
  "notes/deleteNotes",
  async (id: string, { dispatch }) => {
    const response = await CustomAction(
      Api.delete(`${API_DELETE_NOTE}/${id}`),
      dispatch,
      "notes/deleteNotes"
    );
    return response;
  }
);
